module.exports = __webpack_public_path__ + "static/media/video (1).64e8f287.svg";